<template>
  <div ref="infoWindow" :style="contentStyle">
    <div class="info-window-content">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InfoWindow',

  props: {
    clickOutside: {
      type: String,
      required: false,
      default: 'close',
      validator: (value) => ['none', 'close'].includes(value),
    },
  },

  data() {
    return {
      init: false,
    };
  },

  computed: {
    ...mapState({
      google: (state) => state.google.api,
      map: (state) => state.google.map,
      // counterStopped: (state) => state.counter.stopped,
      selectedMarker: (state) => state.markers.selected,
      selectedRegion: (state) => state.dataLayer.active,
      feature: (state) => state.dataLayer.feature,
      featureHover: (state) => state.dataLayer.hover,
      featureClicked: (state) => state.dataLayer.clicked,
      featureEvent: (state) => state.dataLayer.event,
    }),

    infoWindow() {
      return new this.google.maps.InfoWindow({
        disableAutoPan: true,
      });
    },

    // Remove the div when no marker is clicked
    contentStyle() {
      if (this.init) {
        return '';
      }

      return 'display: none';
    },
  },

  watch: {
    selectedMarker(marker) {
      if (marker !== null) {
        this.init = true;
        this.openWindow(marker.position);

        return;
      }

      this.infoWindow.close();
    },

    selectedRegion(region) {
      if (region !== null) {
        this.init = true;
        this.openWindow(region.getProperty('center'));

        return;
      }

      this.infoWindow.close();
    },

    featureClicked(value) {
      if (value) {
        this.infoWindow.close();
      }
    },

    counterStopped(isStopped) {
      if (isStopped && (!this.featureHover || this.featureClicked)) {
        this.infoWindow.close();

        return;
      }

      this.openWindow(this.selectedRegion.getProperty('center'));
    },
  },

  methods: {
    openWindow(position) {
      this.infoWindow.setPosition(position);
      this.infoWindow.open(this.map);
      this.infoWindow.setContent(this.$el);

      this.addListeners();
    },

    addListeners() {
      // close info window on click outside the box
      if (this.clickOutside === 'close') {
        this.google.maps.event.addListener(this.map, 'click', () => {
          this.onClose();
        });
      }

      // check if info window is closed
      this.google.maps.event.addListener(this.infoWindow, 'closeclick', this.onClose);
    },

    onClose() {
      this.google.maps.event.clearInstanceListeners(this.infoWindow);
      this.$store.commit('markers/deselect');
      this.$store.commit('dataLayer/deselect');
    },
  },
};
</script>

<style lang="scss">
  // stylelint-disable declaration-no-important
  .gm-style .gm-style-iw-d {
    overflow: hidden !important;
  }

  .gm-style .gm-style-iw-c {
    box-shadow: 0 -2px 6px rgba($color-silver, .5);
    padding: 0;
    pointer-events: none;
    transform: translate(-50%, 50%) rotate(180deg);

    > button {
      display: none !important;
    }
  }

  .gm-style .gm-style-iw-t::after {
    transform: translate(-50%, 85%) rotate(-225deg);
  }

  .info-window-content {
    transform: rotate(180deg);
  }
</style>
